import { NavigationContainerRef, StackActions } from '@react-navigation/native';
import { resetSPACreateTimestamp } from './common/performance';
import queryString from 'query-string';
import { getEnv, getKrnDomain } from '@/common/api';
import { openUrl } from '@/common/bridge/openUrl';
import { isHalfByBridgeAsync } from '@/common/device-info';
import yoda from '@kibt/bridge';
import { Platform } from 'react-native';

// 最大路由数量，如果超过这个数量，就用新容器打开，不能一直压栈
export const Max_Route_Count = 10;

let _natigation: NavigationContainerRef;

/**
 * @param natigation 全局Root组件先setNavigator， 避免很多文件、Utils里面，都需要useNavigation() 层层透传
 */
export function setNavigation(natigation) {
    _natigation = natigation;
    console.log('setNavigation', natigation);
    if (Platform.OS === 'web') {
        window.__natigation = natigation;
    }
}

export function getNavigation() {
    return _natigation;
}

async function openNavigationByMPA(componentName: string, params: {}) {
    const route2PathnameMap = {
        Detail: '/krn-web/detail',
        OrderConfirm: '/krn-web/order-confirm',
        OrderDetail: '/krn-web/order-detail',
        MyShoppingCar: '/krn-web/my-shopping-car',
        AddressHome: '/krn-web/address',
        AddressAdd: '/krn-web/address',
    };
    // 使用新容器打开
    const url = queryString.stringifyUrl(
        {
            url: `${getKrnDomain()}${route2PathnameMap[componentName]}`,
            query: {
                // SPA H5路由组件
                componentName,
                // 参数
                ...params,
                env: getEnv(),
                // 参数继承
                krnFollowParams: 1,
                // 一码多投地址
                redirectUrl: queryString.stringify(
                    {
                        // 参数拼接两遍吧，防止低版本不支持krnFollowParams
                        ...params,
                        // 删除部分无用的，防止url不可读或重复拼接
                        __launch_options__: null,
                        krnUselessUrl: null,
                        degradeWebUrl: null,
                        redirectUrl: null,
                        bundleId: 'EcommSpaBundle',
                        componentName,
                    },
                    { skipNull: true, skipEmptyString: true },
                ),
                // 删除部分无用的，防止url不可读
                krnUselessUrl: null,
                degradeWebUrl: null,
            },
        },
        { skipNull: true, skipEmptyString: true },
    );

    console.log('openNavigationByMPA url', url);

    try {
        const halfWebview = await isHalfByBridgeAsync();
        await openUrl({
            url,
            halfWebview,
        });
    } catch (e) {
        await openUrl({
            url,
            halfWebview: false,
        });
    }
}

export const navigation = {
    async push(componentName: string, params: any = {}) {
        const routeLength = getNavigation()?.getRootState()?.routes?.length ?? 0;
        // 根据路由堆栈数量判断是否需要用新容器打开
        if (_natigation && routeLength < Max_Route_Count) {
            resetSPACreateTimestamp(componentName, params);
            const pushAction = StackActions.push(componentName, Object.assign({}, params, { componentName }));
            _natigation.dispatch?.(pushAction);
        } else {
            await openNavigationByMPA(componentName, Object.assign({}, params, { componentName }));
        }
    },
    async replace(componentName: string, params: any = {}) {
        if (_natigation) {
            resetSPACreateTimestamp(componentName, params);
            const replaceAction = StackActions.replace(componentName, Object.assign({}, params, { componentName }));
            _natigation.dispatch?.(replaceAction);
        } else {
            await openNavigationByMPA(componentName, Object.assign({}, params, { componentName }));
        }
    },
    async navigate(componentName: string, params: any = {}) {
        const routeLength = getNavigation()?.getRootState()?.routes?.length ?? 0;
        // 根据路由堆栈数量判断是否需要用新容器打开
        if (_natigation && routeLength < Max_Route_Count) {
            resetSPACreateTimestamp(componentName, params);
            _natigation.navigate?.(componentName, Object.assign({}, params, { componentName }));
        } else {
            await openNavigationByMPA(componentName, Object.assign({}, params, { componentName }));
        }
    },
    goBack() {
        if (_natigation) {
            _natigation.goBack();
        } else {
            yoda.component.backOrCloseWeb();
        }
    },
    canGoBack() {
        return _natigation && _natigation.canGoBack?.();
    },
    setParams(params: any) {
        _natigation?.setParams(params);
    },
    getCurrentRoute() {
        return _natigation?.getCurrentRoute();
    },
    backOrClose() {
        if (_natigation && _natigation.canGoBack()) {
            _natigation?.goBack?.();
        } else {
            yoda.component.backOrCloseWeb();
        }
    },
};

/**
 * 链接打开时的appProps
 */
let _appProps;

export function setAppProps(props) {
    _appProps = props;
}

export function getAppProps() {
    return _appProps || {};
}
